export default "__VITE_ASSET__BEWOhWN1__"